export default "__VITE_ASSET__Bg5lbKI1__"